
const m = window.require("truth-helpers/helpers/not");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
